import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-pause\" id=\"icon-pause\"><rect x=\"6\" y=\"4\" width=\"4\" height=\"16\" /><rect x=\"14\" y=\"4\" width=\"4\" height=\"16\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol